import { constructionAsset, constructionEquipment, constructionSafety } from "@pages/Enterprise/Solution/components/Banner/BannerImages";
import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";

export default {
  desc: '4차 산업혁명 시대에 모든 기기를 연결하고 원시 데이터를 지능적인 행동으로 전환하는 수요가 증가하고 있습니다. 이로 인해 AIoT(Artificial Intelligence of Things)라는 개념이 탄생했습니다. AIoT는 인공지능(AI)과 사물인터넷(IoT)의 융합으로, 센서로부터 데이터를 수집할 뿐만 아니라 심층 분석, 자동화, 프로세스 최적화를 정교하게 수행합니다. 스마트 공장에서 스마트 도시까지, AIoT는 기업과 커뮤니티에 새로운 시대를 열고 있습니다.\n\n그렇다면 AIoT란 무엇이며, 기업과 사람들의 삶에 어떤 이점을 제공하며, 왜 기술 시대의 선두주자가 되었을까요? 이 글에서 ORBRO와 함께 알아보세요.',
  keywords: 'AIoT, AIoT 응용, AIoT 기기, 산업 AIoT, AIoT 솔루션',
  ogSite: 'AIoT란? 개념, 응용 및 분류',
  title: 'AIoT란? 개념, 응용 및 분류',
  ogUrl: 'https://orbro.io/blog/aiot',
  ogImg: 'https://lh3.googleusercontent.com/fife/ALs6j_EwHa0_owCKxTqOEFXfbih7LMPbbyCM6KJHeLs7YurkW6si-qhDEtL7nGtiamTnGhG-_Is9TsPbr2zGwXj_jIEMlF60RTXEgkm7XAZSxeEqCfW9XAztOluq3sBbzxNZAnahb3f5SyUvj0OgBNEBa6Qw66LDrzWVW9JXkNvjwKTtugDVuIPR5hsvYyyn9cq597D55Qosap0z_9ziP_rsmT_I6ljjJNYQnQR4a0olVhrkhM49zMw3QdeBQ-Tcs0Atm8fQmVq7Nu4GwQ8xANv_jTZPMzVp2I0DmhaQ713nQGGD0Uohm5Z2cgXIR4BuLFmUIUHDBmbU6APrz5VmGA7BBwVfe5yswLIDiRpsBeETM29IQkWwVQNiQzsbRB7N93gFSc-R5GlrSPfrx9h2p3ed_plnOFqutlgD_kYe12eqGJbtHnTqxmk5akYUX81XelCTuWyYB8R3FD8OU2ATiiQnPpGOrjwnxM3AfOwIXL7ZrAGNU2vULdc8sra7uCdU5L178nTTt4RLo0nH7JBmHpe9V-SiGFjiSWcivh9fZcEtg_Ypj1v2pjnrLC5apZY_ZDSbAv8hErngASx5JhS1Z_jfQSWwo-l1HtV_vQg3R3lNnbNGbjzFBjyErTiAV_34pM9h77ZOY9V_f05n-4dhR5hCF2avmmMWZag6vln0V5uOrcmVz9Ex5g_-ue1wvk2wT95WJ8LFzfJqBLKIc2BevbaRlw1O9rK233bPawKo8J0cRo5JR1v_s_LzyYv22oECKiDm_f9rdY3duPEB3RarieMooZBwT7bKrPlE_uQobxxhJH_Wo1P_y8tXBBGRiig7pgfkSbGNdKWj0vY1HHs2jDly6iEdilFDFbujju1s9vps-6hZHyzT1hZumUJFo1hdgvfszRatAN7B0rB_gR-HC4fMykbhXZXMwMRMY6H8UNG_f2mFnNyoqcs4-_UtBMOgCdji40vhKv3v7t4MMwrKwOVtEW9tej_bCyLp2HwZl7DgLj6hTgpVDogKB2EgrClxhymRm5d57SyDNMjOtWi_J0GG5d5LhRW3HI5rM15d03loBkdNlidPmY4Z7Pcb3_t2q68RzVWG1V2OsD-yzzk20Npq6l0jvCa_xpsqZZnNGtbseYgPe0hM6wBHavqg9Vl99uVmWdQDVFGHC9-vIWes4PDaLQDMAEln7lPIOxtFonzQSFchbroorD1hjJxhBLYLg8kGK_ldef0XxSx0TZ3gibq4WB4qcIajRJdyHPDvu_8FDrqmDXE1bphaRTaXGpoE4CA5GJRwtBeAiakYG_mfslcgH04CjsqY7MIjWL1S9sv1AUJe6ROGZcwKCE7Bdu1QGhbnRIEL1J5n15iBPDAb-9Of3TS8sDltTjS-501YX0JJvXA5cmqJ2vexjf1oRTbTCthwYogyAQZDQfeDXWwNT_7ucZ5i8OmxFb0GQIevIq9ty0aOspgdVSjzfLrxgFzMk5AYEg7kNPsklZTYHaxen5_mljoXcfZB1xF4fIWNPvvAgEQt9NoMfW0Wo5cbjGG02Rf5mOaTQQPDGkmR1nZzlBqweeE0m34zAiCotEW_SZE0CdCs9zGXF5jT7ipj5QEMg7M9mycrtlb8oTJ2RBeopB6f6RYT6yWej2_GjCB1SA=w1432-h1440?auditContext=forDisplay',
  ogType: 'website',
  date: '2025-06-30',
  tag1: '#AIoT',
  tag2: '#AIoT응용',
  tag3: '#AIoT기기',
  tag4: '#산업AIoT #AIoT솔루션',
  text: [
    {
      head: '',
      subHead: '',
      desc: '4차 산업혁명 시대에 모든 기기를 연결하고 원시 데이터를 지능적인 행동으로 전환하는 수요가 증가하고 있습니다. 이로 인해 AIoT(Artificial Intelligence of Things)라는 개념이 탄생했습니다. AIoT는 인공지능(AI)과 사물인터넷(IoT)의 융합으로, 센서로부터 데이터를 수집할 뿐만 아니라 심층 분석, 자동화, 프로세스 최적화를 정교하게 수행합니다. 스마트 공장에서 스마트 도시까지, AIoT는 기업과 커뮤니티에 새로운 시대를 열고 있습니다.\n\n그렇다면 AIoT란 무엇이며, 기업과 사람들의 삶에 어떤 이점을 제공하며, 왜 기술 시대의 선두주자가 되었을까요? 이 글에서 ORBRO와 함께 알아보세요.',
      dot: ''
    },
    {
      head: '1. AIoT란?',
      subHead: '',
      desc: 'AIoT(Artificial Intelligence of Things)는 인공지능(AI)과 사물인터넷(IoT)의 결합입니다:\n\n• IoT: 인터넷에 연결된 기기, 센서, 기계의 생태계로, 환경, 프로세스, 작동 상태에 대한 데이터를 수집합니다.\n\n• AI: 데이터를 분석하고 학습하여 예측이나 자동 행동을 수행합니다.\n\nIoT가 방대한 데이터를 수집하면 AI는 이를 처리하여 패턴과 트렌드를 찾아 실시간으로 결정을 내립니다. 예를 들어, 공장에서 IoT 센서가 모터의 온도와 진동을 측정하고, AI는 이를 분석하여 고장을 미리 예측합니다. 이것이 AIoT의 힘입니다.',
      dot: ''
    },
    {
      head: '2. AIoT의 실제 응용',
      subHead: '',
      desc: '• 스마트 제조 (Smart Manufacturing)\n예측 유지보수: IoT 센서가 진동, 온도, 윤활유를 모니터링하고, AI는 분석을 통해 기계 고장 전에 유지보수를 예약할 수 있게 합니다.\n공급망 최적화: AI는 재고 및 주문 데이터를 기반으로 자재를 자동으로 조정하여 대기 시간과 창고 비용을 줄입니다.\n\n• 스마트 도시 (Smart City)\n스마트 가로등 관리: IoT가 교통량을 측정하고, AI는 분석을 통해 저수요 시간에 밝기를 조정하여 전기를 절약합니다.\n오염 모니터링: 공기 센서가 지속적으로 데이터를 전송하고, AI는 높은 오염 수준을 예측하여 당국이 시민에게 경고할 수 있게 합니다.\n\n• 교통 및 물류\n자율 주행 및 운전 지원: IoT에 연결된 카메라와 레이더, AI는 이미지와 센서 데이터를 처리하여 충돌을 피하고 경로를 최적화합니다.\n창고 추적: RFID와 IoT 센서가 팔레트의 정확한 위치를 파악하고, AI는 병목 지점을 예측하여 재배치를 제안합니다.\n\n• 의료 및 건강 관리\n원격 환자 모니터링: IoT 웨어러블 기기가 심박수, 혈압을 수집하고, AI는 이상 징후를 분석하여 의사에게 경고합니다.\n의약품 관리: IoT 약품 캐비닛이 재고를 자동으로 확인하고, AI는 약품이 거의 다 떨어질 때 보충을 제안합니다.\n\n• 스마트 농업 (Smart Agriculture)\n자동 관개: IoT 토양 수분 및 날씨 센서, AI는 최적의 물 사용량을 분석하여 30-50%의 물을 절약합니다.\n드론을 통한 작물 모니터링: 드론이 이미지를 수집하고, AI는 해충 징후를 분석하여 적시에 관리 조치를 제공합니다.',
      dot: ''
    },
    {
      head: '3. AIoT의 분류',
      subHead: '',
      desc: 'AIoT는 요구와 배포 모델에 따라 다양합니다:\n\n• 데이터 처리 위치에 따른 분류\n엣지 AIoT: 엣지 디바이스에서 데이터를 처리하여 지연을 줄이며, 자율 주행차나 로봇과 같은 실시간 응용에 적합합니다.\n클라우드 AIoT: 복잡한 분석을 위해 데이터를 클라우드 플랫폼으로 전송하며, 큰 계산 능력이 필요한 응용에 적합합니다.\n하이브리드 AIoT: 속도와 분석 능력의 균형을 위해 엣지와 클라우드를 결합합니다.\n\n• 통합 수준에 따른 분류\nAI가 IoT를 지원: AI는 주로 IoT 시스템의 보고서를 분석하는 데 사용됩니다.\nIoT가 AI를 향상: 강력한 AI 시스템이 있으며, IoT는 원시 데이터만 제공합니다.\n완전한 AIoT: AI와 IoT가 데이터 수집부터 피드백까지 모든 단계에서 심층적으로 통합됩니다.',
      dot: ''
    },
    {
      head: '4. AIoT 적용의 이점',
      subHead: '',
      desc: '지능적인 자동화: 수작업을 줄이고 인력을 창의적인 작업에 집중시킵니다.\n\n빠른 의사 결정: 실시간 데이터와 AI 분석으로 변화에 신속하게 대응합니다.\n\n비용 절감: 가동 중단 시간을 줄이고 자재 및 에너지를 최적화합니다.\n\n품질 향상: 생산 프로세스를 엄격히 제어하고 오류를 조기에 감지합니다.\n\n더 나은 사용자 경험: 개인화된 서비스, 사전 알림 및 지원을 제공합니다.',
      dot: ''
    },
    {
      head: '5. AIoT 구현: 실질적인 고려 사항',
      subHead: '',
      desc: '인프라 평가: 네트워크, 센서, 시스템 확장성을 확인합니다.\n\n보안 보장: 데이터 암호화, 접근 제어, GDPR/ISO 표준 준수를 보장합니다.\n\n적절한 플랫폼 선택: 클라우드 또는 엣지, SDK 또는 AI가 내장된 IoT 플랫폼.\n\n인력 교육: AI 전문가, IoT 엔지니어, 운영 부서를 결합합니다.\n\n구체적인 문제에서 시작: 파일럿 프로젝트를 통해 확장하기 전에 시험합니다.',
      dot: ''
    },
    {
      head: '6. 결론',
      subHead: '',
      desc: 'AIoT는 단순한 트렌드가 아니라 기업이 디지털 시대를 정복하기 위한 \'열쇠\'입니다. IoT의 데이터 수집과 AI의 지능적인 분석의 결합은 뛰어난 효율성, 유연성, 혁신 능력을 제공합니다. 지금 바로 AIoT 여정을 시작하여 경쟁 우위를 확보하고 ORBRO와 함께 지속 가능한 미래를 발전시키세요.',
      dot: ''
    }
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'UWB 단말기를 작업자 또는 장비에 부착하여, 실시간으로 위치 추적을 돕는 제품입니다.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/enterprise/construction/safety',
      },
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/enterprise/construction/asset',
      },
      {
        img: constructionEquipment.thumb,
        data: 'constructionEquipment',
        link: '/enterprise/construction/equipment',
      },
    ],
  },
};
